/// <reference path="../../app.definition.ts" />

import angular from "angular";
import * as _ from "lodash";
import * as jsonLogic from "json-logic-js";

import {
    ChartTypeEnum,
    DataProcessTypeEnum,
    DDOptionsSetTypeEnum,
    Field,
    FieldEventTypeEnum,
    FieldOperationEnum,
    FieldProcess,
    FieldProcessTypeEnum,
    FieldSource,
    FieldSourceTypeEnum,
    FieldTypeEnum,
    SelectOption,
    SelectionTypeEnum,
    SetTypeEnum,
    ValueSourceTypeEnum,
} from "@common/model/analytics.model";
import { Subject } from "@common/model/subject";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
import { UtilityService } from "@common/service/util.service";
import { CommonService } from "@common/common.service";
import { Util } from "@common/util";
import { IAppRootScopeService } from "@app/app.definition";


export interface IFieldService {
    init(config, ctrl, stateData): void;
    //destroy(): void;
    // filterFields: Array<Field>;
}

// It's good practice to define this in a shared file
export interface IValueSource {
    distinctBy: any;
    type: any;
    name?: string;
    value?: any;
    filter?: any;
    fireChangeEvent?: boolean;
    order?: number;
    orderBy?: any;
    params?: any;
    key?: string;
    selection?: any;
    options?: any;
    includeEmpty?: boolean;
}

export class FieldService implements IFieldService {
    fields: Array<Field>;
    modelResolution;
    ctrl;
    password;
    currentUserOrgId;
    stateData;
    calculativeCols;
    userId;
    getSignedUrl;
    prntCtrl;
    static $inject = ["$interpolate", "$q", "$rootScope", "$timeout", "ApiAdapterService", "CacheService", "UtilityService", "CommonService"];

    constructor(
        private $interpolate: ng.IInterpolateService,
        private $q: ng.IQService,
        private $rootScope: IAppRootScopeService,
        private $timeout: ng.ITimeoutService,
        private ApiAdapterService: JavaApiAdapterService,
        private CacheService: CacheService,
        private UtilityService: UtilityService,
        private CommonService: CommonService
    ) { }

    init(config, ctrl, stateData) {
        eCareVault.Util = Util;
        this.fields = !!config ? config.fields : null;
        this.modelResolution = {};
        this.calculativeCols = [];
        this.ctrl = ctrl
        this.password = this.CacheService.getPassword();
        var user = this.CacheService.getUser();
        this.currentUserOrgId = !!extModule ? window['userOrgId'] : user.organizationId;
        this.userId = !!extModule ? window['userId'] : user.userId;
        this.stateData = stateData;
        this.getSignedUrl = (bucket, imgUrl) => this.CommonService.getSignUrlFrSignature(bucket, imgUrl);
    }

    resetSrvcValues = (requiredValues) => {
        let service = this;
        _.each(requiredValues, (ob) => {
            var key = "" + ob.split(".").join("['") + "']";
            eval(key + " = null");
        });
    }

    initFields = (fields) => {
        for (let key in fields) {
            this.modelResolution["${" + key + "}"] = "fields." + key;
            !!this.fields[key].source && (this.setDataSource(this.fields[key]));
            if (Array.isArray(this.fields[key].attributes)) {
                this.fields[key].attributes.forEach(a => {
                    a.value = this.resolute(a.value)
                });
            }
        }
    }

    getFields = (filter) => {
        return Object.keys(this.fields)
            .filter(key => this.fields[key].category == filter)
            .reduce((obj, key) => {
                obj[key] = this.fields[key];
                return obj;
            }, {});
    }

    getFieldKeys = (fields) => {
        return Object.keys(fields);
    }

    resolute = (val) => {
        var escapeRegExp = function (str) {
            return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
        for (var key in this.modelResolution) {
            val = val.replace(new RegExp(escapeRegExp(key), 'g'), this.modelResolution[key]);
        }
        return val;
    };

    resolveVar = (val, isCtrl) => {
        return (isCtrl ? "ctrl" : "service") + "['" + val.split(".").join("']['") + "']";
    }

    setDataSource = (field) => {
        switch (field.source.type) {
            case FieldSourceTypeEnum.CALL_API:
                this.callService(this.ApiAdapterService, field.source);
                break;
            case FieldSourceTypeEnum.CALL_CACHE:
                this.callService(this.CacheService, field.source);
                break;
            case FieldSourceTypeEnum.DEPENDENT:
            case FieldSourceTypeEnum.STATIC:
                break;
            case FieldSourceTypeEnum.EXPRESSION:
                field.value = eval(field.source.value);
                break;
            case FieldSourceTypeEnum.EXECUTE_ACTION:
                this.execAction(field.source).then((v) => {
                    field.value = v
                });
                break;
            case FieldSourceTypeEnum.FROM_FIELD_OPTIONS:
                if (field.source.params) {
                    var sField = this.fields[field.source.params.fieldName]
                    if (sField) {
                        field.ddOptions = _.clone(sField.value);
                        if (field.source.params.selected == "all") {
                            field.value = field.ddOptions;
                        }
                    }
                }
                break;
        }
    }

    getValueFromSource = (s) => {
        var obj;
        //process collection
        switch (s.source) {
            case ValueSourceTypeEnum.CONTROLLER_VAR:
                if (s.name) {
                    var ctrl = this.ctrl;
                    obj = eval("ctrl['" + s.name.split('.').join("']['") + "']");
                }
                break;
        }
        return obj;
    }

    callService = (service, source: FieldSource) => {
        var deferred = this.$q.defer();
        if (typeof service[source.action] == "function") {
            var actualCall = () => {
                var dfrd = this.$q.defer();
                var params = [];
                if (source.params) {
                    //extract param values
                    params = this.UtilityService.getValuesFromObject(source.params);
                    params = this.handleParams(params);
                }
                service[source.action](...params).then((data) => {
                    dfrd.resolve(data);
                }).catch((e) => {
                    dfrd.reject(e);
                });

                return dfrd.promise;
            }

            var hasPreProcess = (source.process && source.process[FieldProcessTypeEnum.PRE]);
            var hasPostProcess = (source.process && source.process[FieldProcessTypeEnum.POST]);

            var normalCall = () => {
                actualCall().then((data) => {
                    if (hasPostProcess) {
                        this.handleProcess(source.process[FieldProcessTypeEnum.POST], data).then(() => {
                            deferred.resolve(data);
                        })
                    }
                    else {
                        deferred.resolve(data);
                    }
                }).catch(e => {
                    deferred.reject(e);
                });
            }

            if (hasPreProcess) {
                this.handleProcess(source.process[FieldProcessTypeEnum.PRE]).then(() => {
                    normalCall();
                })
            } else {
                normalCall();
            }
        } else {
            deferred.reject("Method named " + source.action + " not found in Cache.")
        }
        return deferred.promise;
    }

    handleProcess = (process: FieldProcess, result?) => {
        var deferred = this.$q.defer();
        var perform = process.perform;
        if (!!perform && typeof perform == 'object') {
            for (let key in perform) {
                switch (key) {
                    case FieldOperationEnum.SET:
                        this.set(perform[key], result);
                        break;
                    case FieldOperationEnum.EXEC_ACTION:
                        this.executeActions(perform[key], result, false);
                        break;
                    case FieldOperationEnum.EXEC_SERVICES:
                        this.executeActions(perform[key], result, true);
                        break;
                    case FieldOperationEnum.FIRE_EVENT:
                        this.handleEvent(perform[key], true, result);
                        break;
                }
            }
            deferred.resolve();
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    }

    setFieldValue = (field, vs) => {
        if (field) {
            var dispatchChangeEvent = () => {
                var events = field.events;
                if (!!events) {
                    if ('ng-change' in events) {
                        this.$timeout(() => {
                            this.onFieldEvent(events['ng-change'], true);
                        }, 0);
                    }
                    if ('on-firstSet' in events) {
                        this.$timeout(() => {
                            this.onFieldEvent(events['on-firstSet'], false).then(() => {
                                delete events['on-firstSet'];
                                this.stateData = null;
                            });
                        }, 0);
                    }
                }
            };
            const ifValueNotSet = (valSource) => {
                if (valSource['if_value_not_set']) {
                    const process = new FieldProcess(FieldProcessTypeEnum.RUN, valSource['if_value_not_set'])
                    this.handleProcess(process)
                }
            }
            if (Array.isArray(vs)) {
                var breakLoop = false;
                if (vs.length > 1) {
                    vs = vs.sort((a, b) => a.order - b.order);
                }
                for (let item of vs) {
                    switch (item.type) {
                        case ValueSourceTypeEnum.CONTROLLER_VAR:
                        case ValueSourceTypeEnum.SERVICE_VAR:
                            var ctrl = this.ctrl;
                            var service = this;
                            var str = this.resolveVar(item.name, (ValueSourceTypeEnum.CONTROLLER_VAR == item.type));
                            try {
                                var value = eval(str);
                                if (!!value) {
                                    field.value = value;
                                    (_.isNil(item.fireChangeEvent) || item.fireChangeEvent) && dispatchChangeEvent();
                                    breakLoop = true;
                                } else {
                                    ifValueNotSet(item)
                                }
                            } catch (e) {
                                // do nothing as there might be other options to execute and get value

                            }
                            break;

                        case ValueSourceTypeEnum.CALL_CACHE:
                            this.callService(this.CacheService, item).then(value => {
                                value != undefined && (field.value = value) && dispatchChangeEvent();
                            });
                            break;

                        case ValueSourceTypeEnum.SELECT_FROM_OPTIONS:
                            var params = this.handleParams(item.filter);
                            try {
                                var value;
                                if (Array.isArray(field.ddOptions)) {
                                    value = field.ddOptions.filter(i => jsonLogic.apply(params, i));
                                }
                                if (!!value && value.length > 0) {
                                    if (!_.includes([FieldTypeEnum.MULTI_SELECT, FieldTypeEnum.MULTI_SELECT_USER, FieldTypeEnum.MULTI_SELECT_PERSON, FieldTypeEnum.PAGINATED_SUB_LIST], field.type)) {
                                        value = value[0];
                                    }
                                    field.value = value;
                                    dispatchChangeEvent();
                                    breakLoop = true;
                                } else {
                                    ifValueNotSet(item)
                                }
                            } catch (e) {
                                // do nothing as there might be other options to execute and get value
                            }
                            break;
                        case ValueSourceTypeEnum.SELECT_ALL_OPTIONS:
                            if (field.ddOptions) {
                                if (field.type == 'multiSelectPerson') {
                                    field.ddOptions.forEach((x) => { x.selected = true; })
                                }
                                field.value = field.ddOptions;
                                if (!!field.value && !!item.fireChangeEvent) {
                                    dispatchChangeEvent();
                                }
                                breakLoop = true;
                            }
                            break;
                        case ValueSourceTypeEnum.EXECUTE_ACTION:
                            this.execAction(item).then((v) => {
                                field.value = v;
                                if (!!field.value && !!field.fireChangeEvent) {
                                    dispatchChangeEvent();
                                }
                            });
                            break;
                        case ValueSourceTypeEnum.EXPRESSION:
                            field.value = eval(item.value);
                            if (field.type == 'paginatedSubList') {
                                var multiTeams = field.value.map(x => x.subjectId)
                                field.ddOptions && field.ddOptions.subjects.forEach(x => {
                                    if (multiTeams.includes(x.subjectId)) {
                                        x.selected = true;
                                    } else {
                                        x.selected = false;
                                    }
                                })
                            }
                            if (!!field.value && !!field.fireChangeEvent) {
                                dispatchChangeEvent();
                            }
                            break;
                    }
                    if (breakLoop) {
                        break;
                    }
                }
            }
        }
    }

    handleEvent = (fEvent, autoCall = false, result = null) => {
        var deferred = this.$q.defer();
        switch (fEvent.type) {
            case FieldEventTypeEnum.CALL_API:
                this.$rootScope.mainShowLoader = true;
                this.callService(this.ApiAdapterService, fEvent).then(() => {
                    (!autoCall) && (this.$rootScope.mainShowLoader = false);
                    deferred.resolve();
                });
                break;

            case FieldEventTypeEnum.CALL_CACHE:
                this.$rootScope.mainShowLoader = true;
                this.callService(this.CacheService, fEvent).then(() => {
                    !autoCall && (this.$rootScope.mainShowLoader = false);
                    deferred.resolve();
                });
                break;

            case FieldEventTypeEnum.CALL_SERVICE:
                this.$rootScope.mainShowLoader = true;
                this.callService(this, fEvent).then(() => {
                    !autoCall && (this.$rootScope.mainShowLoader = false);
                    deferred.resolve();
                });
                break;

            case FieldEventTypeEnum.EXECUTE_ACTION:
                this.$rootScope.mainShowLoader = true;
                this.execAction(fEvent).then((s) => {
                    deferred.resolve(s);
                }).catch(() => {
                    deferred.reject();
                }).finally(() => {
                    (!autoCall) && (this.$rootScope.mainShowLoader = false);
                });
                break;
            case FieldEventTypeEnum.EXECUTE_PROCESS:
                this.$rootScope.mainShowLoader = true;
                this.handleProcess(fEvent.process[FieldProcessTypeEnum.RUN]).then(() => {
                    deferred.resolve();
                }).catch(() => {
                    deferred.reject();
                });
                break;
            case FieldEventTypeEnum.FILTER_SUBJECTS:
                let evnt = _.cloneDeep(fEvent);
                if (evnt.params && evnt.params.ids) {
                    evnt.params.ids = eval(evnt.params.ids);
                }
                this.callService(this, evnt).then(() => {
                    deferred.resolve();
                }).catch(() => {
                    deferred.reject();
                });
                break;
        }
        return deferred.promise;
    }

    execAction = (obj) => {
        var deferred = this.$q.defer();
        if (typeof this.ctrl[obj.action] == "function") {
            var params = this.UtilityService.getValuesFromObject(obj['params']);
            params = this.handleParams(params);
            this.ctrl[obj.action](...params).then((s) => {
                deferred.resolve(s);
            }).catch(() => { deferred.reject(); });
        } else {
            deferred.reject();
        }
        return deferred.promise;
    }

    getAllSubjects = (filter) => {
        var deferred = this.$q.defer();
        var data = null;
        this.ApiAdapterService.getSubjects().then(data => {
            var subs = data['allSubjects'];
            if (filter) {
                subs = subs.filter(d => {
                    return jsonLogic.apply(filter, d);
                })
            }
            subs = _.orderBy(subs, [cr => cr.fullName.toLowerCase()], ['asc']);
            deferred.resolve(subs);
        });

        return deferred.promise;
    }

    onFieldEvent = (fEvent, autoCall = false) => {
        var deferred = this.$q.defer();
        if (Array.isArray(fEvent)) {
            var promises = [];
            fEvent.forEach((evt) => {
                promises.push(this.handleEvent(evt, autoCall));
            })
            this.$q.all(promises).finally(() => { deferred.resolve() });
        } else {
            this.handleEvent(fEvent, autoCall).finally(() => { deferred.resolve() });
        }
        return deferred.promise;
    }

    set = (options, result) => {
        if (Array.isArray(options) && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                var field = this.fields[options[i].name];
                var vs: IValueSource = options[i].valueSource;
                switch (options[i].type) {
                    case SetTypeEnum.FIELD_VALUE:
                        this.setFieldValue(field, vs);
                        break;
                    case SetTypeEnum.FIELD_OPTIONS:
                        if (field) {
                            if (typeof vs == "string") {
                                field.ddOptions = _.cloneDeep(result);
                            } else if (_.isObject(vs)) {
                                switch (vs.type) {
                                    case DDOptionsSetTypeEnum.DISTINCT_FROM_RESULT:
                                        try {
                                            field.ddOptions = _.uniqBy(result, vs.distinctBy)
                                            if (!!vs.orderBy && !!vs.orderBy.field) {
                                                try {
                                                    field.ddOptions = _.sortBy(field.ddOptions, [vs.orderBy.field], [vs.orderBy.order]);
                                                } catch (e) {
                                                    console.log(e);
                                                }
                                            }
                                            const includeEmpty: boolean =
                                                !!vs.includeEmpty;
                                            let hasEmptyValues: boolean = false;
                                            field.ddOptions = _.map(field.ddOptions, (d) => {
                                                const key = _.get(d, vs.key);
                                                const value = _.get(d, vs.value);
                                                if (!!key && !!value) {
                                                    return new SelectOption(key, value);
                                                }
                                                hasEmptyValues = true;
                                            });
                                            _.remove(field.ddOptions, o => !o);
                                            if (includeEmpty && hasEmptyValues) {
                                                field.ddOptions.unshift(
                                                    new SelectOption(
                                                        '__empty__',
                                                        '-- Empty --'
                                                    )
                                                );
                                            }
                                        } catch (e) {
                                            console.log(e);
                                        }
                                        break;
                                    case DDOptionsSetTypeEnum.FILTER_FROM_PARENT:
                                    case DDOptionsSetTypeEnum.GROUP_FROM_RESULT:
                                        try {
                                            var params = this.handleParams(vs.params);
                                            var parent = params.parent;
                                            var index = parent.indexOf('${_result_}');
                                            (index != -1) && (parent = result);
                                            var oldDdOpts = field.ddOptions;
                                            var indexKey; //index key to compare items in option list

                                            //filter the items from the original ddOptions. (origDdOptions contains the full list of items obtained from backend)
                                            var fltrData = _.filter(field.origDdOptions, function (opt) { return jsonLogic.apply(vs.filter, { opt, parent }); });
                                            if (vs.type == DDOptionsSetTypeEnum.FILTER_FROM_PARENT) {
                                                field.ddOptions = fltrData;
                                                indexKey = 'id';
                                            } else if (vs.type == DDOptionsSetTypeEnum.GROUP_FROM_RESULT) {
                                                indexKey = 'ids';
                                                //grouping the duplicate label items
                                                const grouped = fltrData.reduce((acc, item) => {
                                                    // Find if the current item's label already exists in the accumulator
                                                    const existing = acc.find(group => group.label === item.label);
                                                    if (existing) {
                                                        // If the label exists, push the new id, parentId, and partyId into the existing arrays
                                                        existing.ids.push(item.id);
                                                        existing.parentIds.push(item.parentId);
                                                    } else {
                                                        // If it doesn't exist, create a new group object
                                                        acc.push({
                                                            ids: [item.id],
                                                            label: item.label,
                                                            parentIds: [item.parentId]
                                                        });
                                                    }

                                                    return acc;
                                                }, []);
                                                field.ddOptions = grouped;
                                            }

                                            if (vs.selection) {
                                                let oldOpts = vs.selection.oldOptions;
                                                let newOpts = vs.selection.newOptions;
                                                //remove the selected item from the value if it has been filtered out from the options
                                                _.remove(field.value, (v) => !field.ddOptions.find(d => _.isEqual(d[indexKey], v[indexKey])));

                                                //Select all the options
                                                if (newOpts == SelectionTypeEnum.SELECT_ALL) {
                                                    field.ddOptions.forEach((x) => {
                                                        if (!oldDdOpts.find(d => _.isEqual(d[indexKey], x[indexKey]))) {
                                                            (field.type == 'multiSelectPerson') && (x.selected = true);
                                                            field.value.push(x);
                                                        }
                                                    });
                                                }
                                                switch (oldOpts) {
                                                    case SelectionTypeEnum.RETAIN:
                                                        field.ddOptions.forEach((x) => {
                                                            let oo = oldDdOpts.find(d => _.isEqual(d[indexKey], x[indexKey]));
                                                            if (!!oo) {
                                                                (field.type == 'multiSelectPerson') && (x.selected = oo.selected);
                                                            }
                                                        });
                                                        break;
                                                    case SelectionTypeEnum.SELECT_ALL:
                                                        field.ddOptions.forEach((x) => {
                                                            if (!!oldDdOpts.find(d => _.isEqual(d[indexKey], x[indexKey]))) {
                                                                (field.type == 'multiSelectPerson') && (x.selected = true);
                                                                (!field.value.find(v => _.isEqual(x[indexKey], v[indexKey]))) && (field.value.push(x));
                                                            }
                                                        });
                                                        break;
                                                    case SelectionTypeEnum.DESELECT_ALL:
                                                        field.ddOptions.forEach((x) => {
                                                            if (!!oldDdOpts.find(d => _.isEqual(d[indexKey], x[indexKey]))) {
                                                                (field.type == 'multiSelectPerson') && (x.selected = false);
                                                                _.remove(field.value, (v) => _.isEqual(x[indexKey], v[indexKey]));
                                                            }
                                                        });
                                                        break;
                                                }
                                            }
                                            if (!!vs.orderBy && !!vs.orderBy.field) {
                                                try {
                                                    field.ddOptions = _.sortBy(field.ddOptions, [vs.orderBy.field], [vs.orderBy.order]);
                                                    field.value = _.sortBy(field.value, [vs.orderBy.field], [vs.orderBy.order]);
                                                } catch (e) {
                                                    console.log(e);
                                                }
                                            }

                                        } catch (e) {
                                            console.log(e);
                                        }
                                        break;
                                    case DDOptionsSetTypeEnum.STATIC:
                                        try {
                                            let options = []
                                            options = vs.options.map((a, index) => {
                                                return {
                                                    id: index,
                                                    label: a
                                                }
                                            })
                                            field.ddOptions = options
                                        } catch (e) {
                                            console.log(e);
                                        }
                                        break;
                                }
                            }
                        }
                        break;
                    case SetTypeEnum.CONTROLLER_VAR:
                        var ctrl = this.ctrl;
                        var str = this.resolveVar(options[i].name, true);
                        if (options[i].valueSource) {
                            options[i].valueSource.forEach(vs => {
                                switch (vs.type) {
                                    case ValueSourceTypeEnum.STATIC:
                                        eval(str + " = " + vs.value);
                                        break;
                                }
                            })
                        }
                        break;
                    case SetTypeEnum.SERVICE_VAR:
                        var service = this;
                        var str = this.resolveVar(options[i].name, false);
                        if (options[i].valueSource) {
                            options[i].valueSource.forEach(vs => {
                                switch (vs.type) {
                                    case ValueSourceTypeEnum.STATIC:
                                        eval(str + " = " + vs.value);
                                        break;
                                }
                            })
                        }
                        break;
                    case SetTypeEnum.FIELD_ORIG_OPTIONS:
                        if (typeof vs == "string") {
                            field.origDdOptions = result;
                        }
                        break;
                }
            }
        }
    }

    handleParams = (parameters, prntCtrl?) => {
        var params = _.cloneDeep(parameters);
        var service = this;
        this.prntCtrl = prntCtrl
        var parseValue = (obj, k, str) => {
            switch (typeof str) {
                case 'string':
                    if (str.indexOf("(function(") == 0 || str.indexOf("JSON.") != -1 || str.indexOf("Number(") != -1 || str.indexOf("_.") != -1 || str.indexOf('eCareVault.Util.') != -1) {
                        try {
                            //eval the string expression
                            obj[k] = eval(str);
                        } catch (e) {
                            console.log(e);
                        }
                    } else {
                        //some times the expression will be string onlly
                        obj[k] = str;
                    }
                    break;
                case 'object':
                    for (var index in obj[k]) {
                        parseValue(obj[k], index, obj[k][index]);
                    }
                    break;
            }
        }
        for (var key in params) {
            var jsonParams = "";
            var isJson = false;
            switch (typeof params[key]) {
                case 'number':
                case 'boolean':
                case 'string':
                    jsonParams = params[key].toString();
                    break;
                case 'object':
                    isJson = true;
                    jsonParams = JSON.stringify(params[key]);
                    break;
                default:
                    jsonParams = "";
                    break;
            }
            if (jsonParams.indexOf('${') != -1) {
                jsonParams = this.resolute(jsonParams);
            }
            if (jsonParams.indexOf('{{') != -1) {
                jsonParams = this.$interpolate(jsonParams)(this);
            }
            if (isJson) {
                params[key] = JSON.parse(jsonParams);
                parseValue(params, key, params[key]);
            } else {
                parseValue(params, key, jsonParams);
            }
        }
        return params;
    }

    processData = (data, dProcess, dvConfig) => {
        if (Array.isArray(data) && Array.isArray(dProcess)) {
            _.each(dProcess, (d) => {
                data = this.doDataOperation(d, data);
            });
            if (dvConfig && Array.isArray(dvConfig.charts) && dvConfig.charts.length > 0) {
                var service = this;
                _.each(dvConfig.charts, (dataView) => {
                    if (dataView.type == ChartTypeEnum.TABLE && Array.isArray(dataView.options.columns)) {
                        this.calculativeCols = _.filter(dataView.options.columns, col => !!col.calculateAfterFilter);
                        _.each(data, (row) => {
                            _.each(dataView.options.columns, (col) => {
                                !!col.preCalculations && (eval(col.preCalculations));
                                row[col.valueFieldName] = eval(col.data);
                                row[col.valueFieldName] != 0 && !row[col.valueFieldName] && (row[col.valueFieldName] = "");
                            });
                        });
                    }
                });
            }
        }
        return data;
    }

    processTableData = (data, process, config) => {
        if (Array.isArray(data)) {
            if (Array.isArray(process)) {
                _.each(process, (d) => {
                    data = this.doDataOperation(d, data);
                });
            }
            var service = this;
            var wait;
            var operate = () => {
                if (config.type == ChartTypeEnum.TABLE && Array.isArray(config.options.columns)) {
                    this.calculativeCols = _.filter(config.options.columns, col => !!col.calculateAfterFilter);
                    _.each(data, (row) => {
                        _.each(config.options.columns, (col) => {
                            !!col.preCalculations && (eval(col.preCalculations));
                            let data = eval(col.data)
                            if (typeof data == 'string') {
                                row[col.valueFieldName] = data.trim().length > 0 ? data : "NA";
                            } else {
                                row[col.valueFieldName] = eval(col.data);
                            }
                            row[col.valueFieldName] != 0 && !row[col.valueFieldName] && (row[col.valueFieldName] = "");
                        });
                    });
                }
            };

            if (config && Array.isArray(config.requiredValues)) {
                var checkAndOperate = () => {
                    let hasRequired = true;
                    _.each(config.requiredValues, (ob) => {
                        hasRequired = hasRequired && !!eval(ob);
                    });
                    if (hasRequired) {
                        clearTimeout(wait);
                        operate();
                    } else {
                        wait = setTimeout(() => {
                            checkAndOperate();
                        }, 1000);
                    }
                }
                checkAndOperate();
            } else {
                operate();
            }
        }
        return data;
    }

    doDataOperation = (config, data) => {
        var result = [];
        switch (config.type) {
            case DataProcessTypeEnum.GROUP_BY:
                var colsArr = _.map(config.columns, (a) => "o." + a);
                const groupByCols = "[" + colsArr.join() + "]";
                var data1 = _.groupBy(data, (o) => eval(groupByCols));
                result = _.reduce(data1, (arr, v) => {
                    var obj: any = {};
                    _.each(config.columns, (col) => obj[col] = v[0][col]);
                    obj.groupData = _.reduce(v, (ar, sv) => {
                        var ob: any = {};
                        _.each(config.otherColumns, (col) => {
                            ob[col] = sv[col];
                        });
                        ar.push(ob);
                        return ar;
                    }, [])
                    arr.push(obj);
                    return arr;
                }, []);
                break;
            case 'groupByHistory':
                let cols = config.columns.map((a) => {
                    return "o." + a;
                });
                cols = "[" + cols.join() + "]";

                let arr = [];

                let filterData = _.groupBy(data, (o) => {
                    return eval(cols);
                });

                let keys = Object.keys(filterData).map(Number).sort((a, b) => { return a - b });
                keys.forEach((keyData, index) => {
                    let row = {};
                    if (index > 0) {
                        let val = arr[index - 1].value;
                        if (config.noCopy) {  //Do not copy old values for some columns
                            Object.keys(val).forEach(k => {
                                if (!_.includes(config.noCopy, k)) {
                                    row[k] = val[k];
                                }
                            })
                        } else {
                            row = angular.copy(val);
                        }
                    }
                    filterData[keyData].map((data) => {
                        if (_.includes(config.arrayValue, data.fieldName)) {     //Values of some columns like ficwa recommendations should be added in array.
                            !row[data.fieldName] && (row[data.fieldName] = []);
                            row[data.fieldName].push(data.value);
                        } else {
                            row[data.fieldName] = data.value || "NA";
                        }
                    });
                    arr.push({ time: keyData, value: row });
                });

                result = arr.filter(t => t.time != 0);
                break;
            case DataProcessTypeEnum.MAP_FIELD_OPTIONS:
                this.mapFieldOptions(config)
                result = data;
                break;
            case DataProcessTypeEnum.FILTER:
                result = data.filter((entity) => jsonLogic.apply(config.predicat, entity))
                break;
        }
        return result;
    }

    mapFieldOptions = (config) => {
        var field = this.fields[config.fieldName];
        if (config.fieldName && field) {
            var options = field.ddOptions;
            if (!!config.splitKey) {
                options = _.flatten(_.map(options,
                    (v) => {
                        var a = JSON.parse(v.id);
                        return _.map(a,
                            (d) => {
                                var o = {};
                                o[config.key] = d;
                                o[config.value] = v.label;
                                return o;
                            })
                    })
                );
            }
            this[config.fieldName] = _.reduce(options, (ac, obj) => {
                ac[obj[config.key]] = obj[config.value];
                return ac;
            }, {});
        }
    }

    mapFieldOptionsFromResult = (config, data) => {
        var key = "['" + config.key.split(".").join("']['") + "']";
        var value = "['" + config.value.split(".").join("']['") + "']";
        this[config.fieldName] = _.reduce(data, (ac, obj) => {
            eval("ac[obj" + key + "] = obj" + value);
            return ac;
        }, {});
    };

    fetchSubjects(ids, filter, useCahe = true) {
        var deferred = this.$q.defer();
        (typeof useCahe === 'string') && (useCahe = (useCahe === 'true'));
        var data = [], notCached = [];
        var sendData = () => {
            data = _.orderBy(data, [cr => cr.fullName.toLowerCase()], ['asc']);
            deferred.resolve(data);
        };
        if (useCahe) {
            let allSub = this.CacheService.getSortedSubjects();
            if (filter) {
                allSub = allSub.filter(d => {
                    return jsonLogic.apply(filter, d);
                })
            }
            ids.forEach((id) => {
                let sub = allSub.find(s => s.subjectId == id);
                if (!!sub) {
                    data.push(new Subject().deserialize(sub));
                } else {
                    notCached.push(id);
                }
            });
        } else {
            notCached = ids;
        }
        if (notCached.length > 0) {
            this.ApiAdapterService.getPartySubjectsById(notCached).then((d) => {
                data = data.concat(d);
                sendData();
            },
                (e) => {
                    sendData();
                });
        } else {
            sendData();
        }

        return deferred.promise;
    }

    executeActions = (actions, result, forServices = false) => {
        var context = (forServices ? this : this.ctrl);
        if (Array.isArray(actions)) {
            for (var key in actions) {
                var call, params;
                if (typeof actions[key] == "string") {
                    call = context[actions[key]]
                    params = [];
                } else {
                    call = context[actions[key]['action']];
                    params = this.UtilityService.getValuesFromObject(actions[key]['params']);
                    params = this.handleParams(params);
                    var index = params.findIndex(p => p == '${_result_}');
                    if (index != -1) {
                        params[index] = result;
                    }
                }
                if (typeof call == "function") {
                    call(...params);
                } else {
                    throw ("Controller Method " + call + " not defined");
                }
            }
        }
    }

    resetFieldValues = (fields) => {
        var deferred = this.$q.defer();
        var flag = false;
        fields.forEach(f => {
            try {
                this.fields[f].value = null;
                flag = true;
            } catch (e) {
                console.log("Field not found while resetting.")
            }
        });
        if (flag) {
            deferred.resolve();
        } else {
            deferred.reject();
        }
        return deferred.promise;
    }
}


angular.module('eCareVault.common.services')
    .service('FieldService', FieldService);
